module.exports = __webpack_public_path__ + "assets/img/dada4b0d3fcb57ce15aaf57767e584cb.svg";